import Operator from "./filters/operator";
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder() {
    }
    QueryBuilder.create = function () {
        return new QueryBuilder();
    };
    QueryBuilder.prototype.term = function (term) {
        this._term = term;
        return this;
    };
    QueryBuilder.prototype.filter = function (filter) {
        this._filter = filter;
        return this;
    };
    QueryBuilder.prototype.paging = function (page, size) {
        this._pagination = { page: page, size: size };
        return this;
    };
    QueryBuilder.prototype.pagingInfinity = function () {
        this._pagination = { page: 0, size: '∞' };
        return this;
    };
    QueryBuilder.prototype.sort = function () {
        var orders = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            orders[_i] = arguments[_i];
        }
        this._sort = orders;
        return this;
    };
    QueryBuilder.prototype.appendOrder = function (field, direction) {
        if (!this._sort) {
            this._sort = [];
        }
        this._sort.push({ field: field, direction: direction });
        return this;
    };
    QueryBuilder.prototype.aggregations = function (aggregations) {
        this._aggregations = aggregations;
        return this;
    };
    QueryBuilder.prototype.addAggregation = function (field, aggregation) {
        if (!this._aggregations) {
            this._aggregations = {};
        }
        this._aggregations[field] = aggregation;
        return this;
    };
    QueryBuilder.prototype.build = function () {
        var allQueryFields = {
            term: this._term,
            filter: this._filter,
            pagination: this._pagination,
            sort: this._sort,
            aggregations: this._aggregations,
        };
        return Object.keys(allQueryFields).reduce(function (previousValue, currentValue) {
            if (allQueryFields[currentValue] !== undefined) {
                previousValue[currentValue] = allQueryFields[currentValue];
            }
            return previousValue;
        }, {});
    };
    QueryBuilder.parseFilter = function (str) {
        var result = JSON.parse(str);
        if ('operator' in result && result.operator in Operator) {
            return result;
        }
        throw new Error('unable to parse filter');
    };
    return QueryBuilder;
}());
export default QueryBuilder;
